module.exports = __webpack_public_path__ + "static/media/DSC_0158-2.a85e7345.jpg";